import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import withAttr from 'flarum/common/utils/withAttr';
import isValidUrl from '../helpers/isValidUrl';
import IconSelectorComponent from './IconSelectorComponent';
export default class WebsiteInputComponent extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "button", void 0);
    _defineProperty(this, "allowsExternal", void 0);
    _defineProperty(this, "waitUntilFinished", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.button = this.attrs.button;
    this.allowsExternal = app.forum.attribute('fof-socialprofile.allow_external_favicons') || false;
  }
  view(vnode) {
    return m("div", {
      className: "Form-group form-group-social",
      id: "socialgroup-".concat(this.button.index())
    }, m("input", {
      type: "text",
      className: "FormControl SocialFormControl SocialFormControl-title",
      placeholder: app.translator.trans('fof-socialprofile.forum.edit.title'),
      tabIndex: (this.button.index() + 1) * 2 - 1,
      bidi: this.button.title
    }), IconSelectorComponent.component({
      selection: this.button.icon,
      favicon: this.button.favicon,
      index: this.button.index,
      allowsExternal: this.allowsExternal,
      url: this.button.url
    }), m("input", {
      type: "text",
      className: "FormControl SocialFormControl SocialFormControl-url",
      placeholder: app.translator.trans('fof-socialprofile.forum.edit.url'),
      tabIndex: (this.button.index() + 1) * 2,
      value: this.button.url(),
      onchange: withAttr('value', this.onUrlChange.bind(this))
    }), m("input", {
      type: "hidden",
      className: "FormControl SocialFormControl SocialFormControl-icon",
      id: "icon".concat(this.button.index(), "-icon"),
      bidi: this.button.icon
    }), m("input", {
      type: "hidden",
      className: "SocialFormControl SocialFormControl-favicon",
      id: "icon".concat(this.button.index(), "-favicon"),
      bidi: this.button.favicon
    }));
  }
  onUrlChange(value) {
    this.button.url(value);
    if (!this.allowsExternal) {
      return;
    }
    clearTimeout(this.waitUntilFinished);
    if (this.button.icon() !== 'fas fa-circle-notch fa-spin') {
      this.button.icon('fas fa-circle-notch fa-spin');
      this.button.favicon('none');
    }
    this.waitUntilFinished = setTimeout(() => {
      if (isValidUrl(this.button.url())) {
        this.button.icon('favicon');
        this.button.favicon('external');
      } else {
        this.button.icon('fas fa-globe');
        this.button.favicon('none');
      }
      m.redraw();
    }, 1000);
  }
}
flarum.reg.add('fof-socialprofile', 'forum/components/WebsiteInputComponent', WebsiteInputComponent);